import React, { useReducer, useState } from 'react';
import { BreadCrumb, FooterSection } from '../components';
import { TrainClasses } from '../route_info/TrainClasses';
import { DivertedTrainPageData, DivertedTrainType } from '../types';
import Diverted from '../components/Diverted.js';
import '../../styles/UpdateCenterCommon.css';
import { searchWidgetInitialState, searchWidgetReducer } from '../../reducers/searchWidgetReducer';
import SearchWidget from '../components/SearchWidget/SearchWidget';
import HtmlHeader from '../components/HtmlHeader';
import { FOOTER_DATA_IRCTC, IRCTC_EXTERNAL_JS } from '../../utils/RailsSEOConstants';
import { getStaticPageLoadEvent } from '../../utils/omnitureUtils';

type DivertedTrainPageDataProps = {
  data: DivertedTrainPageData;
};
const SearchWidgetContext = React.createContext<any>(searchWidgetInitialState);

const DivertedTrains = ({ data }: DivertedTrainPageDataProps) => {
  const [searchWidgetState, searchWidgetDispatch] = useReducer(searchWidgetReducer, searchWidgetInitialState);
  const [searchQuery, setSearchQuery] = useState('');
  return (
    <div>
      <SearchWidgetContext.Provider value={{ searchWidgetState, searchWidgetDispatch }}>
        <SearchWidget
          openDatePickerOnMount={false}
          topFix={true}
          classNode={TrainClasses.FC}
          pageWiseContext={SearchWidgetContext}
        />
      </SearchWidgetContext.Provider>

      <div className="container">
        <HtmlHeader data={data} />
        <BreadCrumb breadcrumb={data.template.breadcrumb} />

        <div className="heading">
          <h1 className="appendTop15 appendBottom15 font22">{data.template.h1_title}</h1>
        </div>
        <div className="rescheduledWrap">
          <div className="widgetWrap">
            <div className="widgetInner">
              <div className="searchWrap">
                <span className="searchTitle">SEARCH</span>
                <input
                  type="text"
                  placeholder="By Train Name/ Number or Date"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value.toLowerCase())}
                />
              </div>
            </div>
          </div>
          <main className="container">
            {typeof window !== 'undefined' &&
              data?.divertedTrainList?.map((train) => {
                if (
                  train.trainName.toLowerCase().includes(searchQuery) ||
                  train.trainNo.toLowerCase().includes(searchQuery) ||
                  train.startDate.toLowerCase().includes(searchQuery)
                )
                  return <Diverted {...train} />;
              })}
          </main>
        </div>
      </div>
      <FooterSection template={data.template} />
    </div>
  );
};

DivertedTrains.fetchData = async () => {
  const divertedTrainList: DivertedTrainType[] = [];
  const allDivertedTrainsResponse = await fetch('https://rails-junction.redbus.in/apis/v1/diverted_trains/', {
    method: 'GET',
    headers: { 'X-CLIENT-NAME': 'junction' }
  });
  const allDivertedTrains = await allDivertedTrainsResponse.json();

  if (allDivertedTrains.data) {
    Object.keys(allDivertedTrains.data).forEach((dateKey) => {
      divertedTrainList.push(allDivertedTrains.data[dateKey]);
    });
  }
  const template = {
    template_name: `route`,
    pageUrl: `https://www.makemytrip.com/railways/diverted-trains.html`,
    meta_title: `Check Indian Railways Diverted Trains, Diverted Train List`,
    meta_description: `Check India railways diverted trains at MakeMytrip.com. Check the list of all diverted trains with details like train name and train number.`,
    meta_keywords: `diverted trains, diverted trains today, diverted train list, diverted train status, today’s diverted trains, train diverted means`,
    analytics: getStaticPageLoadEvent('seo:rails:diverted:trains'),
    footer_data: FOOTER_DATA_IRCTC,
    h1_title: `Indian Railways Diverted Trains`,
    breadcrumb: [
      {
        redirectionUrl: `https://www.makemytrip.com/`,
        displayString: `Home`
      },
      {
        redirectionUrl: `https://www.makemytrip.com/railways/`,
        displayString: `Rails`
      },
      {
        displayString: `Diverted Trains`,
        redirectionUrl: `https://www.makemytrip.com/railways/diverted-trains.html`
      }
    ],
    banner_desktop: ``,
    banner_mobile: ``,
    sample_url: `https://www.makemytrip.com/railways/diverted-trains.html`,
    external_js: IRCTC_EXTERNAL_JS,
    extra_info: ``
  };

  const finalResponse = {
    template,
    divertedTrainList
  };
  const pageType = 'trains';
  const cacheKey = 'HTML_STATIC_DIVERTED-TRAINS.HTML';
  return {
    pushToCache: true, // if this is set then after ssr it will be stored in cache
    cacheKey,
    pageType,
    ...finalResponse
  };
};

export default DivertedTrains;
